var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.293 60H53.6055V66.6667H58.293V60Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1602 60H62.4727V66.6667H67.1602V60Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.293 45H53.6055V51.6667H58.293V45Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1602 45H62.4727V51.6667H67.1602V45Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.293 30H53.6055V36.6667H58.293V30Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1602 30H62.4727V36.6667H67.1602V30Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1602 15H62.4727V21.6667H67.1602V15Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4102 60H27.7227V66.6667H32.4102V60Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2598 60H36.5723V66.6667H41.2598V60Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4102 45H27.7227V51.6667H32.4102V45Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2598 45H36.5723V51.6667H41.2598V45Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2598 30H36.5723V36.6667H41.2598V30Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6772 75.3125V0H62.5561L49.7417 13.4239H36.66L19.1977 31.7172V75.3125H11.0156V70.3527C14.6619 69.3273 17.3438 65.9747 17.3438 62.0053C17.3438 57.2236 13.4536 53.3334 8.67188 53.3334C3.89016 53.3334 0 57.2234 0 62.0052C0 65.9747 2.68187 69.3273 6.32812 70.3525V75.3125H0V80H80V75.3125H75.6772ZM4.6875 62.0052C4.6875 59.8081 6.47484 58.0208 8.67188 58.0208C10.8689 58.0208 12.6562 59.8081 12.6562 62.0052C12.6562 64.2022 10.8689 65.9895 8.67188 65.9895C6.47484 65.9895 4.6875 64.2023 4.6875 62.0052ZM45.0938 75.3125H23.8852V33.5953L38.6658 18.1114H45.0938V75.3125ZM70.9897 75.3125H49.7812V20.1714L64.5617 4.6875H70.9897V75.3125Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility1);
export default __webpack_public_path__ + "static/media/gefion-facility-1.817b5ae1.svg";
export { ForwardRef as ReactComponent };